export default {
  'passwordReset.title': 'Password reset',
  'passwordReset.changeButton': 'Change password',
  'passwordReset.sendLink': 'Send link',
};
